/**
 * 相談申し込みの状況のステータス: 調整中
 */
export const HOTLINE_REQUEST_STATUS_SCHEDULING = {
    label: '調整中',
    value: 'SCHEDULING',
};
/**
 * 相談申し込みの状況のステータス: 相談予定
 */
export const HOTLINE_REQUEST_STATUS_SCHEDULED = {
    label: '相談予定',
    value: 'SCHEDULED',
};
/**
 * 相談申し込みの状況のステータス: 相談完了
 */
export const HOTLINE_REQUEST_STATUS_COMPLETED = {
    label: '相談完了',
    value: 'COMPLETED',
};
/**
 * 相談申し込みの状況のステータス: キャンセル
 */
export const HOTLINE_REQUEST_STATUS_CANCELED = {
    label: 'キャンセル',
    value: 'CANCELED',
};
/**
 * 相談申し込みの状況のステータス 一覧
 */
export const HOTLINE_REQUEST_STATUSES = [
    HOTLINE_REQUEST_STATUS_SCHEDULING,
    HOTLINE_REQUEST_STATUS_SCHEDULED,
    HOTLINE_REQUEST_STATUS_COMPLETED,
    HOTLINE_REQUEST_STATUS_CANCELED,
];
